/**
 * @deprecated
 * Local feature flags are no longer supported and this file will be removed in a future release.
 * For more details, checkout the "Feature Flags Overview" section in the README.
 */

const isDevelopmentEnv = import.meta.env.VITE_ENV === 'development' && typeof (window as any).Cypress === 'undefined';

const fetchLocalFeatureFlags = async () => {
  try {
    const res = await fetch('/local-feature-flags.json');
    return await res.json();
  } catch {
    if (import.meta.env.DEV) {
      throw new Error(
        'Missing local-feature-flags.json. Please create a copy of example-local-feature-flags.json with the required feature flags.',
      );
    }
    return {};
  }
};

export const combineWithLocalFeatureFlags = async (ldFlags: { [key: string]: boolean }) =>
  isDevelopmentEnv ? { ...ldFlags, ...(await fetchLocalFeatureFlags()) } : ldFlags;
